import { zKUploadFileIdValidator } from '@knitiv/api-client-javascript';
import APIV5 from '~/models/api';
import KDate from '~/models/kdate';
import mime from '~/scripts/constants/mime';

/* globals Knitiv, Chat */

/**
 * @returns {Chat.Attachment}
 */
function createAttachmentError() {
	return {
		infos: {
			mimetype: '',
			datecreation: '',
			filename:	'',
			name: 'Impossible de récupérer le fichier',
			nodeid: '',
			packetindex: 0,
			size: 0,
			packetnb: 0,
			packetsize: 0,
			status: 'END',
			version: '',
			version_sys: '',
			extension: '',
			hash: '',
		},
		isNode: true,
		viewer: undefined,
		state: {
			data: {
				collapsed: true,
			},
			ref: null,
		},
	};
}
export default class Message {
	/**
	 * @param {Chat.Message} message
	 * @param {import('angular').IQService} $q
	 * @param {Knitiv.RootScope} $rootScope
	 */
	constructor(
		message,
		$q,
		$rootScope,
	) {
		// @ts-ignore
		// eslint-disable-next-line no-underscore-dangle
		if (message._exist_ === 0) {
			return;
		}
		/**
		 * @type {'sent' | 'errored' | 'seen' | undefined}
		 */
		this.status = message.status;
		this.create_date = message.create_date;
		this.from_profil_kid = message.from_profil_kid;
		this.room_kid = message.room_kid;
		this.text = message.text;
		this.update_date = message.update_date;
		this.ref = '';
		if (message.status !== 'errored') {
			this.ref = message.ref;
			this.datecreation = message.datecreation;
			// @ts-ignore
			this.id = message.ref.replace('KCHATMSG;', '');
			this.fileid = message.fileid;
			this.reply_ref = message.reply_ref;
			this.state = message.state;
			this.to_profil_kid = message.to_profil_kid;
		}

		this.previewURL = undefined;

		/** @type {(Chat.Attachment | undefined)} */
		this.attachment = undefined;
		this.isOpened = true;
		this.$q = $q;
		this.$rootScope = $rootScope;
	}

	/**
	 *
	 * @returns {Promise<Message>}
	 */
	async init() {
		if (this.fileid && this.fileid !== '0') {
			try {
				await this.fetchAttachment();
				return this;
			}
			catch (error) {
				console.error(error);
			}
		}
		return this;
	}

	/**
	 * Fetch the message corresponding to the reply target of the current message
	 *
	 * @returns {Promise<Message | undefined>}
	 */
	async fetchReply() {
		if (this.reply_ref) {
			try {
				const data = await APIV5.instance.get({
					elt_kid: this.reply_ref,
					kparam: {
						module: 'chat',
						kdate: KDate.now().asString(),
					},
				});

				return data[data.elt_kid].data;
			}
			catch {
				if (this.$q && this.$rootScope) {
					return new Message({
						text:            'Message not found',
						status:          'errored',
						ref:             'KCHAT;0',
						datecreation:    '',
						state:           1, // internal
						create_date:     '',
						update_date:     '',
						reply_ref:       '0',
						from_profil_kid: 'K_NODE;0',
						to_profil_kid:   'K_NODE;0',
						room_kid:        'K_NODE;0',
						fileid:          '0',
					}, this.$q, this.$rootScope);
				}
				return undefined;
			}
		}
		return undefined;
	}

	async attachmentsInfos() {
		if (!this.fileid) {
			return undefined;
		}
		try {
			const infos = await APIV5.instance.fileInfo({
				nodeid: this.fileid,
				// kparam: {
				// 	module: 'chat',
				// 	kdate: KDate.now().asString(),
				// },
			}, {
				id:              'message.attachments-infos',
				endpointVersion: this.$rootScope?.kds ? 3 : 2,
			});

			const stateResult = await APIV5.instance.list({
				elt_kid: 'KCHATFILE;0',
				filter:  {
					'SQL_=': {
						file_kid: this.fileid,
					},
				},
				kparam:  {
					module: 'chat',
					kdate:  KDate.now().asString(),
				},
			});

			if (stateResult.elt_nb > 0 && this.attachment) {
				const matches = Object.values(stateResult.elts);
				const element = matches[0];
				const state = JSON.parse(element.data);
				this.attachment.state.data = state;
				this.attachment.state.ref = element.ref;
			}

			if (this.attachment?.state) {
				this.isOpened = !this.attachment.state.data.collapsed;
			}

			if (infos.error) {
				this.attachment = createAttachmentError();
				return this.attachment;
			}

			if (this.attachment) {
				this.attachment.infos = infos;

				this.attachment.viewer = mime[this.attachment.infos.mimetype];
			}

			return this.attachment;
		}
		catch (error) {
			console.warn('error', error);
			this.attachment = createAttachmentError();
			return this.attachment;
		}
	}

	downloadAttachment() {
		if (!this.fileid) {
			return;
		}
		const url = APIV5.instance.downloadURL({
			nodeid: this.fileid,
		});

		window.open(url, '_self');
	}

	async fetchAttachment() {
		let isNode = true;

		const response = zKUploadFileIdValidator.safeParse(this.fileid);
		isNode = !response.success;

		this.attachment = {
			infos: undefined,
			viewer: undefined,
			isNode,
			state: {
				ref: null,
				data: {
					collapsed: false,
				},
			},
		};

		return this.attachmentsInfos();
	}
}
